export const WEIGHT_PROFILES = [
    {
        id: 'quick-cash',
        name: '⚡ Renda Rápida',
        description: 'Prioriza rapidez de faturamento e baixo investimento inicial.',
        weights: {
            imn: 0.25,
            iap: 0.25,
            icp: 0.20,
            ird: 0.15,
            ien: 0.15,
        },
    },
    {
        id: 'build-wealth',
        name: '🏗️ Construir Patrimônio',
        description: 'Prioriza escalabilidade, recorrência e margem de longo prazo.',
        weights: {
            imn: 0.30,
            iap: 0.25,
            icp: 0.20,
            ird: 0.15,
            ien: 0.10,
        },
    },
    {
        id: 'personal-fulfillment',
        name: '🎯 Realização Pessoal',
        description: 'Prioriza compatibilidade com gostos, propósito e motivação pessoal.',
        weights: {
            imn: 0.20,
            iap: 0.25,
            icp: 0.30,
            ird: 0.10,
            ien: 0.15,
        },
    },
    {
        id: 'balanced',
        name: '⚖️ Balanceado',
        description: 'Distribuição equilibrada entre todos os fatores.',
        weights: {
            imn: 0.25,
            iap: 0.25,
            icp: 0.20,
            ird: 0.15,
            ien: 0.15,
        },
    },
];
